// extracted by mini-css-extract-plugin
export var container = "Video-module--container--TS1k0";
export var framed = "Video-module--framed--xHZX0";
export var playIcon = "Video-module--playIcon--hu6V0";
export var playIconWrapper = "Video-module--playIconWrapper--ZI25o";
export var poster = "Video-module--poster--bl0qO";
export var reactPlayer = "Video-module--reactPlayer--PfY1U";
export var root = "Video-module--root--GB8b3";